import {post, get} from "./request";
const businessURL = '/api'

//获取字典数据
const apiSysDictDataGetList = (type) => {
    return get(`/sys/dictData/getList?type=${type}`, {}, {baseURL: businessURL})
}

//获取字典数据
const apiConfigsSysFlowNodeConfigCustomList = (type) => {
    return get(`/configs/sysFlowNodeConfig/customList?bustype=${type}`, {}, {baseURL: businessURL})
}

//获取自定义表单配置首页列表数据
const apiCustomformList = (params) => {
    return post(`/customform/list`, params)
}

//获取查询语句配置
const apiCustomformGetListSqlClauseInfo = (id) => {
    return get(`/customform/getListSqlClauseInfo?id=${id}`, {})
}

//保存查询语句配置
const apiCustomformFromdatasetSave = (params) => {
    return post(`/customform/fromdataset/save`, params)
}

//获取查询参数配置列表
const apiCustomformFromdatasetargListSingle = (params) => {
    return post(`/customform/fromdatasetarg/listSingle`, params)
}

//获取枚举类型
const apiCustomformGetEnumList = (type) => {
    return get(`/customform/getEnumList/${type}?required=true`, {})
}

//获取字段映射列表
const apiCustomformFromdatasetfieldListSingle = (params) => {
    return post(`/customform/fromdatasetfield/listSingle`, params)
}

//删除明细页面配置数据
const apiCustomformDeleteCustomFromDetailShip = (id) => {
    return get(`/customform/deleteCustomFromDetailShip?formId=${id}`, {})
}

//获取数据集列表
const apiCustomformFromdatasetList = (params) => {
    return post(`/customform/fromdataset/list`, params)
}

//获取数据集列表
const apiCustomformFromdatasetDelete = (params) => {
    return post(`/customform/fromdataset/delete`, params)
}

//获取字段映射列表数据
const apiCustomformFromdatasetgroupList = (params) => {
    return post(`/customform/fromdatasetgroup/list`, params)
}

//字段映射 重置配置
const apiCustomformFromdatasetfieldReload = (id) => {
    return post(`/customform/fromdatasetfield/reload/${id}`, {})
}

//字段映射 清楚缓存
const apiCustomformFromdatasetfieldClear = (params) => {
    return post(`/customform/fromdatasetfield/clear`, params)
}

//字段映射 分组数据
const apiCustomformFromdatasetfieldList = (params) => {
    return post(`/customform/fromdatasetfield/list`, params)
}

//字段映射 删除子项
const apiCustomformFromdatasetfieldDelete = (params) => {
    return post(`/customform/fromdatasetfield/delete`, params)
}

//字段映射 删除分组
const apiCustomformFromdatasetgroupDelete = (params) => {
    return post(`/customform/fromdatasetgroup/delete`, params)
}

//修改 数据源选择列表
const apiCustomformDatasourceconfigNodeList = (params) => {
    return post(`/customform/datasourceconfig/nodeList`, params)
}

//获取列表数据
const apiCustomformGet = (id) => {
    return get(`/customform/get?id=${id}`, {})
}

//修改列表数据
const apiCustomformSave = (params) => {
    return post(`/customform/save`, params)
}

//删除列表数据
const apiCustomformDelete = (params) => {
    return post(`/customform/delete`, params)
}

//导出
const apiCustomformExport = (busType) => {
    return post(`/customform/export?businessType=${busType}`, {}, {responseType: 'blob'})
}

const apiCustomformFromdatasetGet = (id) => {
    return get(`/customform/fromdataset/get?id=${id}`, {})
}

const apiCustomformFromdatasetgroupGet = (id) => {
    return get(`/customform/fromdatasetgroup/get?id=${id}`, {})
}

const apiCustomformFromdatasetgroupSave = (params) => {
    return post(`/customform/fromdatasetgroup/save`, params)
}

const apiCustomformFromdatasetfieldBatchGroup = (groupId, params) => {
    return post(`/customform/fromdatasetfield/batchGroup/${groupId}`, params)
}

const apiCustomformFromdatasetfieldGet = (id) => {
    return get(`/customform/fromdatasetfield/get?id=${id}`, {})
}

const apiCustomformFromdatasetfieldGetDesensitizatType = () => {
    return get(`/customform/fromdatasetfield/getDesensitizatType`, {})
}

const apiCustomformFromdatasetfieldSave = (params) => {
    return post(`/customform/fromdatasetfield/save`, params)
}

const apiCustomformAddShip = (params) => {
    return post(`/customform/addShip`, params)
}

const apiCustomformFromdatasetListSingleData = (formId, id) => {
    return get(`/customform/fromdataset/listSingleData?formId=${formId}&id=${id}`, {})
}

export {
    apiCustomformFromdatasetListSingleData,
    apiCustomformAddShip,
    apiCustomformFromdatasetfieldSave,
    apiCustomformFromdatasetfieldGetDesensitizatType,
    apiSysDictDataGetList,
    apiConfigsSysFlowNodeConfigCustomList,
    apiCustomformList,
    apiCustomformGetListSqlClauseInfo,
    apiCustomformFromdatasetSave,
    apiCustomformFromdatasetargListSingle,
    apiCustomformGetEnumList,
    apiCustomformFromdatasetfieldListSingle,
    apiCustomformDeleteCustomFromDetailShip,
    apiCustomformFromdatasetList,
    apiCustomformFromdatasetDelete,
    apiCustomformFromdatasetgroupList,
    apiCustomformFromdatasetfieldReload,
    apiCustomformFromdatasetfieldClear,
    apiCustomformFromdatasetfieldList,
    apiCustomformFromdatasetfieldDelete,
    apiCustomformFromdatasetgroupDelete,
    apiCustomformDatasourceconfigNodeList,
    apiCustomformGet,
    apiCustomformSave,
    apiCustomformDelete,
    apiCustomformExport,
    apiCustomformFromdatasetGet,
    apiCustomformFromdatasetgroupGet,
    apiCustomformFromdatasetgroupSave,
    apiCustomformFromdatasetfieldBatchGroup,
    apiCustomformFromdatasetfieldGet,
}